export default __webpack_public_path__ + "static/media/bite-logo.a248e82c.png";